var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-form"},[_c('div',{staticClass:"model-content"},[_vm._l((_vm.data.list),function(element,index){return [(element && element.key)?_c('model-form-item',{key:element.key,attrs:{"element":element,"index":index,"data":_vm.data}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }